<template>
    <div class="user-testing-page-db-update">
        <div class="container">
            <div class="loader-svg">
                <div class="logo-animate">
                    <img :src="logoMain" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    .loader-svg {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(#000, .6);
        z-index: 9;
        user-select: none;
        .logo-animate {
            position: absolute;
            top: 40%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 260px;
            img {
                width: 100%;
                height: auto;
                animation: reveal 5s linear infinite;
            }
        }
    }
    @keyframes reveal {
        0%, 100% {
            clip-path: inset(0 100% 0 0); /* В начале и в конце анимации изображение скрыто */
        }
        50% {
            clip-path: inset(0 0 0 0); /* На половине пути изображение полностью видно */
        }
    }
</style>

<script>
    import { doc, getDoc, updateDoc } from "firebase/firestore"; 
    export default {
        name: 'user-testing--page-update-db',
        components: {
        },
        data () {
            return {
                logoMain: require('@/assets/images/logo-main.png'),
            }
        },
        methods: {
            async updateUserTestingDB() {
                const url = new URL(window.location.href);
                const URL_userID = url.searchParams.get('userID');
                const userRef = doc(this.$db, "users", URL_userID);
                const userSnap = await getDoc(userRef);
                console.log(URL_userID);
                if (userSnap.exists()) {
                    console.log(userSnap.data());
                    if (userSnap.data().codes == null) {
                        await updateDoc(userRef, {
                            'user.online_test' : true,
                        });
                        this.$router.push('/');
                    } else {
                        console.log('false')
                        this.$router.push('/');
                    }
                } else {
                    console.log("No such USER DB!");
                    this.$router.push('/');
                }
            }
        },
        beforeRouteEnter (to, from, next) {
            next();
        },
        created () {
            this.updateUserTestingDB();
        },
        mounted() {
        },
    }
</script>